import type { Session } from '@/models/auth'

export function currentBusinessName(session: Session | null | undefined): string | null {
  const name = session?.businesses.find((item) => item.businessId === session.businessId)?.businessName?.trim()
  return name || null
}

export function forThisBusiness(session: Session | null | undefined): string {
  const name = currentBusinessName(session)
  return name ? `for ${name}` : 'for this business'
}
